import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthority } from '../utils/authority';

export const withAuthorized = (WrappedComponent) => {
  return (props) => {
    const authority = getAuthority();

    if (!authority.includes('AUTHED')) {
      return <Navigate to="/signin" />;
    }

    return <WrappedComponent {...props} />;
  };
};